
export type TrendingHashtagsResponseHashtagsItem = {
  id?: string;
  name?: string;
  tweetCount?: number;
};
